import { formatTime, shortDateFormat, formatDate } from "utils/dates"
import { dayjsWithTimezone } from "utils/dates"

export const defaultTimeWithHour = hour =>
  dayjsWithTimezone()
    .set("hour", hour)
    .set("minute", 0)
    .format()

export const sessionsDateFormatter = (showsAt, hidesAt) => {
  const showsAtFormat = timeFormat(showsAt, differentTimePeriods(showsAt, hidesAt))
  const hidesAtFormat = timeFormat(hidesAt, true)
  const showsAtFormatted = formatTime(showsAt, showsAtFormat)
  const hidesAtFormatted = formatTime(hidesAt, hidesAtFormat)
  const dateFormat = shortDateFormat()
  const formattedDate = formatDate(showsAt, dateFormat)

  return `${formattedDate} ${showsAtFormatted} - ${hidesAtFormatted}`
}

const timeFormat = (time, showPeriod) => {
  if (App.currentOrganization.twentyFourHourTime) {
    return "HH:mm"
  } else {
    const hasMinutes = new Date(time).getMinutes() !== 0
    let format = "h"

    if (hasMinutes) format = "h:mm"
    if (showPeriod) format += "a"

    return format
  }
}

const sameTimePeriods = (firstTime, secondTime) =>
  new Date(firstTime).getHours() > 12 && new Date(secondTime).getHours() > 12

const differentTimePeriods = (firstTime, secondTime) => !sameTimePeriods(firstTime, secondTime)
